const globals = {
    apiUrl: 'https://i.thorbroadcast.com/api'
}
export default globals
